export const onDeleteEntry = id => ({
  widget: 'entries',
  type: 'onDeleteEntry',
  payload: { id },
})



// WEBPACK FOOTER //
// ./src/entries/actions/onDeleteEntry.js